<template>
    <button
        :disabled="disabled"
        @click="$emit('click')"
        class="btn btn-session d-flex justify-content-center align-items-center position-relative"
        ref="button"
    >
        <span class="label" :class="{ hide: loading }">
            <slot></slot>
        </span>
        <div v-if="loading" class="spinner-container spinner-container-animate" role="status">
            <div class="spinner">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </button>
</template>

<script>
export default {
    name: "SessionButton",
    props: {
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        unfocus() {
            this.$refs.button.blur()
        },
    },
}
</script>

<style lang="scss" scoped>
.spinner {
    border: 2.5px solid rgba(255, 255, 255, 0.6);
    border-top-color: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 0.75s cubic-bezier(0.5, 0.1, 0.25, 1) infinite;
    transition: all 0.75s;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.spinner-container {
    width: 20px;
    height: 20px;
    position: absolute;
}

.spinner-container-animate {
    animation-fill-mode: backwards;
    animation: move 0.25s ease-out forwards;
}

@keyframes move {
    0% {
        transform: translateX(10px);
    }
    100% {
        transform: translateX(0px);
    }
}

.label {
    transition: opacity 0.2s;
    &.hide {
        opacity: 0;
    }
}

.disabled {
    cursor: default;
}
</style>